import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SeoHead from "@/components/feature/SeoHead";
import SchemaMarkup from "@/components/feature/SchemaMarkup";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <SeoHead />
        <SchemaMarkup />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;